import ViewMaintenanceItem from "../common/view-maintenance-item";

export default function ViewCompanyLogbookMaintenanceItem() {
  return <ViewMaintenanceItem />;
}
